(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // CMS içerik alanı medya: çoklu görsel swiper + mp4 / YouTube oynatma.
  // Tüm swiper örnekleri .cms-swiper sınıfı ile scope'lanır; sayfa içinde çakışmaz.
  DNB.CmsMedia = {
    init: function () {
      var scope = document.querySelector(".page-body__content");
      if (!scope || scope.getAttribute("data-cms-media-init") === "1") return;
      scope.setAttribute("data-cms-media-init", "1");

      initSwipers(scope);
      initVideos(scope);
    }
  };

  function initSwipers(scope) {
    if (!window.Swiper) return;

    scope.querySelectorAll(".cms-swiper").forEach(function (el) {
      if (el.getAttribute("data-cms-swiper-init") === "1") return;
      el.setAttribute("data-cms-swiper-init", "1");

      new window.Swiper(el, {
        slidesPerView: 1,
        speed: 500,
        loop: el.querySelectorAll(".swiper-slide").length > 1,
        pagination: {
          el: el.querySelector(".swiper-pagination"),
          clickable: true
        }
      });
    });
  }

  function initVideos(scope) {
    ensurePopup();

    scope.querySelectorAll(".cms__split-media--video").forEach(function (media) {
      var play = media.querySelector(".cms__split-play");
      if (!play || play.getAttribute("data-cms-video-bound") === "1") return;
      play.setAttribute("data-cms-video-bound", "1");

      play.addEventListener("click", function () {
        var video = media.querySelector("video");
        var youtubeId = media.getAttribute("data-youtube-id");

        if (video) {
          video.setAttribute("controls", "controls");
          video.play();
          media.classList.add("is-playing");
          return;
        }

        if (youtubeId) {
          openYoutube(youtubeId);
        }
      });
    });
  }

  function ensurePopup() {
    if (document.querySelector("[data-cms-video-popup]")) return;

    var popup = document.createElement("div");
    popup.className = "cms-video-popup";
    popup.setAttribute("data-cms-video-popup", "");
    var closeLabel = (document.documentElement.getAttribute("lang") || "").toLowerCase().indexOf("en") === 0
      ? "Close"
      : "Kapat";
    popup.innerHTML =
      '<button type="button" class="cms-video-popup__backdrop" data-cms-video-close aria-label="' + closeLabel + '"></button>' +
      '<div class="cms-video-popup__panel">' +
        '<button type="button" class="cms-video-popup__close" data-cms-video-close aria-label="' + closeLabel + '">' +
          '<span class="icon icon--close-light" aria-hidden="true"></span>' +
        '</button>' +
        '<div class="cms-video-popup__frame" data-cms-video-frame></div>' +
      '</div>';

    document.body.appendChild(popup);

    popup.querySelectorAll("[data-cms-video-close]").forEach(function (btn) {
      btn.addEventListener("click", closeYoutube);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeYoutube();
    });
  }

  function openYoutube(id) {
    var popup = document.querySelector("[data-cms-video-popup]");
    var frame = popup && popup.querySelector("[data-cms-video-frame]");
    if (!popup || !frame) return;

    var videoId = DNB.extractYoutubeId(id);
    if (!videoId) return;

    frame.innerHTML =
      '<iframe src="' + DNB.buildYoutubeEmbedUrl(videoId, { mute: false }) +
      '" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen title="YouTube video"></iframe>';
    popup.classList.add("is-open");
    if (DNB.ScrollService) DNB.ScrollService.lock();
  }

  function closeYoutube() {
    var popup = document.querySelector("[data-cms-video-popup]");
    if (!popup || !popup.classList.contains("is-open")) return;

    var frame = popup.querySelector("[data-cms-video-frame]");
    popup.classList.remove("is-open");
    if (frame) frame.innerHTML = "";
    if (DNB.ScrollService) DNB.ScrollService.unlock();
  }
})(window, document);
